import { Divider, Popconfirm } from "antd"
import { Link, Links } from "react-router-dom"
   const GenerateLink = ({config , item}) =>{
        if (config.withPrompt){
            return(<Popconfirm title={"This action will "+item} onConfirm={config['onClick']}>
                <a href="#" className="text-blue-500">{item}</a>
            </Popconfirm>)
        }
        return (<a href="#" key={item} className="text-blue-500" onClick={config['onClick']}>{item}</a>)

    }

const ExtraOptions = ({options , keyPrefix}) =>{
 
    return (
        <div className="m-auto" >
            {
                Object.keys(options).map((item,idx)=>{
                    if(idx == Object.keys(options).length-1){
                        return <GenerateLink key={item+idx} config={options[item]}  item={item}/>
                    }
                    return (
                        <>
                        <GenerateLink key={item+idx} config={options[item]}  item={item}/><Divider type="vertical"/>
                        
                        </>
                    )
                })
            }
        </div>
    
    )

}

export default ExtraOptions